import { RadiatorDisabledIcon } from './RadiatorDisabledIcon';

/**
 * author: Michael Irigoyen
 * id 79B0F153-88BE-4FCD-94CB-E44D648DAAE2
 * name radiator-disabled
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiator-disabled.svg
 * tags
 * - Home Automation 
 */
export const HeaterDisabledIcon = RadiatorDisabledIcon;
export default HeaterDisabledIcon